import pendo, { LEARNER_API_KEY } from 'js/lib/pendo';
import user from 'js/lib/user';

import type { DegreesV1 } from 'bundles/degree-home/components/__generated__/DegreesV1';

/**
 * initializePendo - Initialize and configure Pendo
 * @param {DegreesV1} degreeMetadata
 * @param {string} degreeSlug
 */
export const initializePendo = (degreeMetadata: DegreesV1, degreeSlug: string) => {
  const { external_id: externalId, is_staff: isStaff, is_superuser: isSuperuser } = user.get();
  // Init Pendo
  pendo.init(
    {
      visitor: {
        id: externalId,
        isStaff,
        isSuperuser,
      },

      account: {
        id: degreeMetadata?.id,
        name: degreeMetadata?.name,
        slug: degreeSlug,
        internalLaunchType: degreeMetadata?.internalLaunchType,
        productVariant: degreeMetadata?.productVariant,
      },
    },
    LEARNER_API_KEY
  );
};

export default initializePendo;
